import { post, postWithBlobResponse } from 'services/http';

const getTableAnswerColumnModifications = (answerId, interpretationId) =>
  post(`/answers/column-modifications/${answerId}/${interpretationId}`, null, { addKgId: true, addSessionId: true });

const getFilterTemplates = (answerId, interpretationId, candidateId, representedRelation) =>
  post(
    '/answers/filter-templates',
    {
      answerId,
      interpretationId,
      candidateId,
      representedRelation
    },
    { addSessionId: true }
  );

const downloadAnswerAsExcel = exportOptions => {
  const body = {
    exportOptions,
    fileType: 'xlsx'
  };
  return postWithBlobResponse(`/answers/partials/export`, body, { addKgId: true, addSessionId: true });
};

export default {
  getTableAnswerColumnModifications,
  getFilterTemplates,
  downloadAnswerAsExcel
};
